<template>
    <div>
      <v-list>
        <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="title">
                {{ user.name }}
              </v-list-item-title>
              <v-list-item-subtitle>{{ roles }}</v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>
      
      <v-list
        nav
        dense
      >
        <v-list-item-group
          v-model="selectedItem"
          color="primary"
        >
          <v-list-item
            @click="onMenuClick(item.url)"
            v-for="(item, i) in permittedMenuItems"
            :key="i"
          >
            <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title v-text="item.name"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>

          <v-list-item @click="logout()">
            <v-list-item-icon>
              <v-icon v-text="'mdi-logout'"></v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title v-text="'Sair'"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
      </v-list>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Sidemenu',
  data: () => ({
    selectedItem: null,
    menuItems: [
      {
        name: 'Ativos',
        icon: 'mdi-cash-marker',
        url: "/assets",
        permission: "read_assets",
      },
      {
        name: 'Documentos',
        icon: 'mdi-clipboard-list',
        url: "/registrationArea",
        permission: "read_assets",
      },
      {
        name: 'Categorias',
        icon: 'mdi-text-box-multiple',
        url: "/categories",
        permission: "read_assets",
      },
      {
        name: 'Subcategorias',
        icon: 'mdi-text-box-multiple',
        url: "/subcategories",
        permission: "read_assets",
      },
      {
        name: 'Clientes',
        icon: 'mdi-account',
        url: "/clients",
        permission: "read_clients",
      },
      {
        name: 'Movimentação de ativos',
        icon: 'mdi-chart-line',
        url: "/movimentActivesList",
        permission: "read_clients",
      },
      {
        name: 'Posição de ativos',
        icon: 'mdi-chart-line-variant',
        url: "/positionActivesList",
        permission: "read_clients",
      },
      // {
      //   name: 'Taxas de Operação',
      //   icon: 'mdi-message-alert',
      //   url: "/fees",
      //   permission: "read_assets",
      // },
      {
        name: 'Perfis de Acesso',
        icon: 'mdi-account-group',
        url: "/user-roles",
        permission: "read_user_roles",
      },
      {
        name: 'Usuários',
        icon: 'mdi-account-box',
        url: "/users",
        permission: "read_users",
      },
    ]
  }),
  computed: {
    ...mapGetters(['user', 'permissions']),

    permittedMenuItems () {
      return this.menuItems.filter(e => this.permissions[e.permission] || e.permission == 'read_home');
    },

    roles () {
      return this.user.roles.map((e) => (e.name)).sort().join(", ");
    }
  },
  methods:{
    logout: function () {
      this.$store.dispatch('logout')
        .then(() => this.$router.push('/login') )
        .catch(() => this.$router.push('/login') );
    },

    onMenuClick(url){
      this.$router.push(url).catch(error => {
        if (error.name !== 'NavigationDuplicated' && !error.message.includes('Avoided redundant navigation to current location')) 
          console.log(error);
      });
    }
  }
};
</script>
